import { createApp } from 'vue';
import OtfToWoff2Converter from '@/Components/OtfToWoff2Converter.vue';
import '@styles/app.css';

createApp(OtfToWoff2Converter).mount('#otf-to-woff2-converter');
